<template>
  <div
    v-if="showContentDeliverer"
    class="container justify-content-center px-0"
  >
    <div class="sticky">
      <h1 v-if="title" class="text-center">ЖУРНАЛ СДАЧИ ЯГОД</h1>
    </div>

    <div class="main-content">
      <div
        v-for="(delivery, index) in deliveries"
        :key="index"
        class="container pb-2"
      >
        <div class="card lh-1">
          <div class="card-body">
            <div class="row row-cols-2">
              <div class="col text-muted">Дата</div>
              <div class="col text-muted">Номер</div>
              <div class="col">
                <span class="fs-3">{{
                  new Date(delivery.date).toLocaleString()
                }}</span>
              </div>
              <div class="col">
                <span class="fs-3">{{ delivery.number }}</span>
              </div>
            </div>

            <div class="row row-cols-1 pt-2">
              <div class="col text-center">
                <span class="fs-1"
                  ><strong>{{ delivery.berry.label }}</strong></span
                >
              </div>
            </div>

            <div class="row row-cols-2 pt-2 text-center">
              <div class="col text-muted">Вес, кг</div>
              <div class="col text-muted">Цена, руб/кг</div>
              <div class="col pt-1">
                <span class="fs-1 lh-1">{{ delivery.weight }}</span>
              </div>
              <div class="col pt-0">
                <span class="fs-1 lh-1">{{ delivery.price }}</span>
              </div>
            </div>

            <div class="row row-cols-2 pt-2 text-center">
              <div class="col text-muted">Сумма, руб</div>
              <div class="col text-muted">Сумма с бонусами, руб</div>

              <div class="col pt-0">
                <span class="fs-1 lh-1"
                  ><strong>{{ delivery.sum.toFixed(2) }}</strong></span
                >
              </div>
              <div class="col pt-0">
                <span class="fs-1 lh-1"
                  ><strong>{{ delivery.total.toFixed(2) }}</strong></span
                >
              </div>
            </div>

            <div class="row row-cols-1 pt-2 text-center">
              <div class="col text-muted">Приемщик</div>
              <div class="col pt-0">
                <span v-if="getProfile(delivery.company).receiver" class="fs-1 lh-4">{{
                  getProfile(delivery.company).receiver.fullname
                }}</span>
              </div>
              <div class="col pt-0">
                <span v-if="getProfile(delivery.company).receiver" class="fs-1 lh-4">{{
                  getProfile(delivery.company).receiver.address
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import useCommonMixin from "@/components/commonMixin.js";

export default {
  name: "Deliveries",
  props: {
    title: { default: true },
  },
  components: {},
  setup(props) {
    const store = useStore();
    useCommonMixin();
    const { showContentDeliverer, asyncForEach } = useCommonMixin();
    const deliveries = ref([]);
    const profiles = ref([]);

    const getProfile = (profileId) => {
      let profileIndex = profiles.value.findIndex(
        (item) => item && item._id == profileId
      );
      return profileIndex >= 0
        ? profiles.value[profileIndex]
        : { company: "", fullname: "" };
    };

    const init = async () => {
      const response = await store.dispatch("FETCHacceptance");
      const docs = response.status ? response.data : [];
      console.log("docs", docs);
      asyncForEach(docs, async (doc) => {
        let response, ind;
        ind = profiles.value.findIndex((item) => item && item._id == doc.company);
        if (ind < 0) {
          response = await store.dispatch("FETCHuserProfile", {
            userId: doc.company,
            phone: null,
          });
          profiles.value.push(response);
        }

        let docDeliveries = doc.tableUnit.map((item) => {
          item.date = doc.date;
          item.number = `${doc.prefix}-${doc.number}`;
          item.company = doc.company;
          item.sum = doc.sum;
          item.total = doc.total;
          return item;
        });
        deliveries.value = deliveries.value.concat(docDeliveries);
      });

      await store.dispatch("FETCHberry");
    };

    const getBerryLabel = (berryId) => {
      let berry = store.getters.getBerry(berryId);
      return berry ? berry.label : "";
    };

    onMounted(init);

    return {
      getBerryLabel,
      deliveries,
      getProfile,
      showContentDeliverer,
    };
  },
};
</script>

<style>
</style>

